<template>
  <section class="bg-white dark:bg-gray-900">
    <div class="py-8 px-4 mx-auto max-w-screen-xl lg:py-16">
      <h2 class="mb-4 text-xl font-bold text-gray-900 dark:text-white text-center">Citas</h2>

      <!-- Filtros -->
      <div class="grid gap-4 md:grid-cols-2 lg:grid-cols-3 mb-6">
        <!-- Filtro Enfermero -->
        <div>
          <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Filtrar por Enfermero</label>
          <select v-model="filtroEnfermero" @change="aplicarFiltros"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white">
            <option value="">Todos</option>
            <option v-for="enfermero in enfermeros" :key="enfermero.id" :value="enfermero.id">
              {{ enfermero.nombre }}
            </option>
          </select>
        </div>

        <!-- Filtro Paciente -->
        <div>
          <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Filtrar por Paciente</label>
          <input v-model="filtroPaciente" @input="aplicarFiltros" type="text"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
            placeholder="Nombre del paciente" />
        </div>

        <!-- Filtro Mes -->
        <div>
          <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Filtrar por Mes</label>
          <input v-model="filtroMes" @change="logFiltroMes" type="month"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white" />

        </div>
        <div>
          <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Estado:</label>
        <select v-model="filterCompletada"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"

        >
               <option selected :value="true">Completados</option>
          <option :value="false">Pendientes</option>
        </select>
        </div>
      </div>

      <!-- Tabla -->
      <div class="mt-8 flex flex-col flex-no-wrap justify-center items-center">
        <div class="relative overflow-x-auto shadow-md sm:rounded-lg w-full">
          <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" class="px-4 py-3 sm:px-6 lg:px-8">Paciente</th>
                <th scope="col" class="px-4 py-3 sm:px-6 lg:px-8">Enfermero</th>
                <th scope="col" class="px-4 py-3 sm:px-6 lg:px-8">Fecha</th>
                <th scope="col" class="px-4 py-3 sm:px-6 lg:px-8">Hora</th>
                <th scope="col" class="px-4 py-3 sm:px-6 lg:px-8">Total Pagado</th>
                <th scope="col" class="px-4 py-3 sm:px-6 lg:px-8">Método Pago</th>

                <th scope="col" class="px-4 py-3 sm:px-6 lg:px-8">Código Confirmación</th>
                <th scope="col" class="px-4 py-3 sm:px-6 lg:px-8">Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="cita in citasFiltradas" :key="cita.id"
                class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                <th scope="row"
                  class="px-4 py-4 sm:px-6 lg:px-8 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                  {{ cita.paciente.nombre }} {{ cita.paciente.apellido }}
                </th>
                <td class="px-4 py-4 sm:px-6 lg:px-8">
                  {{ obtenerNombreEnfermero(cita.enfermero) }}
                </td>
                <td class="px-4 py-4 sm:px-6 lg:px-8">{{ formatearFecha(cita.fecha) }}</td>
                <td class="px-4 py-4 sm:px-6 lg:px-8">{{ cita.hora }}</td>
                <td class="px-4 py-4 sm:px-6 lg:px-8">${{ cita.costoTotal?.toFixed(2) }}</td>
                <td class="px-4 py-4 sm:px-6 lg:px-8">{{ cita.metodoPago|| 'Sin Pagar' }}</td>

                <td class="px-4 py-4 sm:px-6 lg:px-8">{{ cita.codigoEmail || "N/A" }}</td>
                <td class="px-4 py-4 sm:px-6 lg:px-8">
                  <span :class="cita.tratamientoCompletado ? 'text-green-500' : 'text-yellow-500'">
                    {{ cita.tratamientoCompletado ? 'Completada' : 'Pendiente' }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { collection, onSnapshot } from "firebase/firestore";
import { db } from '../../firebase';
import { formatIsoPrDateKey } from "@/utils/prTime";

export default {
  name: 'CitasCompletadas',
  data() {
    return {
      citas: [],
      enfermeros: [],
      filtroEnfermero: '',
      filtroPaciente: '',
      filtroMes: '',
      filterCompletada: true
    };
  },
  computed: {
    citasFiltradas() {
   

      // Si filtroMes está vacío o no se ha seleccionado nada, no se aplica filtro por mes.
      if (!this.filtroMes) {
        return this.citas.filter(cita => {
          const cumpleEnfermero = !this.filtroEnfermero || cita.enfermero === this.filtroEnfermero;
        const isCompletada = this.filterCompletada == cita.tratamientoCompletado

          const cumplePaciente = !this.filtroPaciente ||
            `${cita.paciente.nombre || cita.paciente} ${cita.paciente.apellido || ''}`.toLowerCase()
              .includes(this.filtroPaciente.toLowerCase());
          return cumpleEnfermero && cumplePaciente  && isCompletada;
        });
      }

      // Convertir el valor de filtroMes (formato "YYYY-MM") en mes y año numérico
      const [ano, mes] = this.filtroMes.split('-');  // Separa la fecha en año y mes
      const filtroAnoNum = parseInt(ano);            // Año: 2024
      const filtroMesNum = parseInt(mes) - 1;       // Mes: diciembre -> 11

      return this.citas.filter(cita => {
        const fechaKey = formatIsoPrDateKey(cita.fecha);
        const fecha = fechaKey ? new Date(`${fechaKey}T12:00:00Z`) : null;
        const cumpleEnfermero = !this.filtroEnfermero || cita.enfermero === this.filtroEnfermero;
        const isCompletada = this.filterCompletada == cita.tratamientoCompletado
        const cumplePaciente = !this.filtroPaciente ||
          `${cita.paciente.nombre || cita.paciente} ${cita.paciente.apellido || ''}`.toLowerCase()
            .includes(this.filtroPaciente.toLowerCase());

        // Compara el mes de la cita con el mes del filtro
        const cumpleMes = fecha ? fecha.getUTCMonth() === filtroMesNum : false;  // Compara correctamente el mes (0-11)
        const cumpleAno = fecha ? fecha.getUTCFullYear() === filtroAnoNum : false;  // Compara el año

        return cumpleEnfermero && cumplePaciente && cumpleMes && cumpleAno &&  isCompletada;
      });
    }
  },
  methods: {
    formatearFecha(fecha) {
    const fechaKey = formatIsoPrDateKey(fecha);
    if (!fechaKey) return "";
    const base = new Date(`${fechaKey}T12:00:00Z`);
    return base.toLocaleDateString("es-PR", {
      timeZone: "America/Puerto_Rico",
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    });
  },
    logFiltroMes() {
      this.aplicarFiltros(); // Asegúrate de llamar a aplicarFiltros después de cambiar el mes
    },
    aplicarFiltros() {
      // Puedes agregar lógica aquí si necesitas realizar alguna acción adicional
      // cuando el filtro de enfermero, paciente o mes cambie.
      this.citasFiltradas; // Computed property se recalculará automáticamente
    },
    cargarCitas() {
      onSnapshot(collection(db, "citasGlobales"), snapshot => {
        this.citas = snapshot.docs.map(doc => {
          const data = doc.data();
          return {
            id: doc.id,
            ...data,
            fecha: data.fecha,
            tratamientoCompletado: data.tratamientoCompletado || false,
          };
        });
      });
    },
    cargarEnfermeros() {
      onSnapshot(collection(db, "enfermeros"), snapshot => {
        this.enfermeros = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      });
    },
    obtenerNombreEnfermero(uid) {
      const enfermero = this.enfermeros.find(e => e.id === uid);
      return enfermero ? enfermero.nombre : 'Sin Asignar';
    },
  },
  mounted() {
    this.cargarCitas();
    this.cargarEnfermeros();
  }
};
</script>

<style scoped>
/* No se necesitan estilos adicionales ya que usamos Tailwind */
</style>
